/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Local_OnlyInputs */

const th_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะในเครื่องนี้`)
};

const en_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local only`)
};

const ja_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルのみ`)
};

const zh_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅本地`)
};

const es_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo local`)
};

const pt_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas local`)
};

const id_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokal saja`)
};

const fr_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local uniquement`)
};

const tl_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokal lamang`)
};

const vi_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ nội bộ`)
};

const ko_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로컬 전용`)
};

const de_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur lokal`)
};

const ru_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только локально`)
};

const tr_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca yerel`)
};

const it_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo in locale`)
};

const pl_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko lokalnie`)
};

const uk_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лише локально`)
};

const hi_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल स्थानीय`)
};

const ar_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محلي فقط`)
};

const ms_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setempat sahaja`)
};

const bn_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুধু স্থানীয়`)
};

const zh_tw2_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限本機`)
};

const zh_hk2_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅限本機`)
};

const ur_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صرف مقامی`)
};

const fa_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فقط محلی`)
};

const sw_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndani pekee`)
};

const nl_local_only = /** @type {(inputs: Local_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen lokaal`)
};

/**
* | output |
* | --- |
* | "Local only" |
*
* @param {Local_OnlyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const local_only = /** @type {((inputs?: Local_OnlyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_OnlyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_local_only(inputs)
	if (locale === "ja") return ja_local_only(inputs)
	if (locale === "zh") return zh_local_only(inputs)
	if (locale === "es") return es_local_only(inputs)
	if (locale === "pt") return pt_local_only(inputs)
	if (locale === "id") return id_local_only(inputs)
	if (locale === "fr") return fr_local_only(inputs)
	if (locale === "tl") return tl_local_only(inputs)
	if (locale === "vi") return vi_local_only(inputs)
	if (locale === "ko") return ko_local_only(inputs)
	if (locale === "de") return de_local_only(inputs)
	if (locale === "ru") return ru_local_only(inputs)
	if (locale === "tr") return tr_local_only(inputs)
	if (locale === "it") return it_local_only(inputs)
	if (locale === "pl") return pl_local_only(inputs)
	if (locale === "uk") return uk_local_only(inputs)
	if (locale === "hi") return hi_local_only(inputs)
	if (locale === "ar") return ar_local_only(inputs)
	if (locale === "ms") return ms_local_only(inputs)
	if (locale === "bn") return bn_local_only(inputs)
	if (locale === "zh-TW") return zh_tw2_local_only(inputs)
	if (locale === "zh-HK") return zh_hk2_local_only(inputs)
	if (locale === "ur") return ur_local_only(inputs)
	if (locale === "fa") return fa_local_only(inputs)
	if (locale === "sw") return sw_local_only(inputs)
	if (locale === "nl") return nl_local_only(inputs)
	return en_local_only(inputs)
});